'use client';
import { XCircle } from 'lucide-react';
import React from 'react';

interface TProps {
    heading?: string;
    subHeading?: React.ReactNode;
    painPoints?: string[];
    footerText?: string;
}

const ProblemSection = ({
    heading = "Struggling to Increase Ticket Sales & Visitor Footfall?",
    subHeading = (
        <>
            Many attractions rely only on walk-ins, manual promotions, or outdated systems that limit visibility and reduce booking conversions. Without the right technology and marketing support, growing visitor numbers becomes difficult.
            <br />
            Greet helps attractions improve online bookings, simplify operations, and create better visitor experiences that drive repeat customers and higher revenue.
        </>
    ),
    painPoints = [],
    footerText = "Greet removes all these barriers - so you can focus on growing your attraction, not chasing bookings."
}: TProps) => {
    return (
        <section className='bg-white pt-16 lg:pt-24'>
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
                <div className='p-6 sm:p-10'>
                    <div className='mb-10 flex flex-col items-center gap-4 text-center'>
                        <h2 className='text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl leading-tight'>
                            {heading}
                        </h2>
                        <p className='max-w-3xl text-base text-gray-500 font-semibold'>
                            {subHeading}
                        </p>
                    </div>

                    <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-4'>
                        {painPoints.map((point) => (
                            <div
                                key={point}
                                className='rounded-xl border border-red-100 bg-gradient-to-br from-white to-red-50 p-5 cursor-pointer'
                            >
                                <div className='flex items-start gap-3'>
                                    <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500'>
                                        <XCircle className='h-4 w-4' />
                                    </div>
                                    <p className='text-sm text-gray-700 font-medium sm:text-base leading-snug'>
                                        {point}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {footerText && (
                        <div className='mt-6 rounded-xl p-4 text-center sm:p-5 bg-gradient-to-r from-primary via-primary/80 to-primary'>
                            <p className='text-sm sm:text-base font-semibold text-white'>
                                {footerText}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
